<app-spinner></app-spinner>
<!-- <router-outlet></router-outlet> -->

<div class="container-fluid mt-2 ms-0">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5>{{ translation.t('adminDepManagement', 'title') }}</h5>
    <button class="btn dept  hover-light"
      style="background-color: #226CE0;box-shadow: none;padding: 5px 8px; border-radius: 6px !important;"
      (click)="open(addDepartmentModal)">
      <img src="../../../../assets/img/cfc/services/Plus.svg" alt="plus" style="width: 16px; height: 16px;">
      <span class="p-1 text-white">{{ translation.t('adminDepManagement', 'addNewDepartment') }}</span>
    </button>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div style="font-weight: 500; font-size: 20px;">{{ translation.t('adminDepManagement', 'allDepartments') }}</div>
    <div class="input-group mb-3" style="max-width: 300px;">
      <span class="input-group-text bg-white border-end-0">
        <img src="../../../../assets/img/cfc/services/Icon.svg" alt="icon" style="width: 16px; height: 16px;">
      </span>
      <input type="text" class="form-control" style="border: 1px solid gainsboro;" [placeholder]="translation.t('adminDepManagement', 'searchPlaceholder')"
        [(ngModel)]="searchText" (input)="onSearchChange()">

    </div>
  </div>

  <div class="table-responsive" style="border-radius: 10px !important;">
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th class="sr-col">{{ translation.t('adminDepManagement', 'srNo') }}</th>
          <th>{{ translation.t('adminDepManagement', 'departmentName') }}</th>
          <th>{{ translation.t('adminDepManagement', 'code') }}</th>
          <!-- <th class="text-center">Escalation Start Level</th> -->
          <!-- <th>{{ translation.t('adminDepManagement', 'complaintTypes') }}</th> -->
          <th>{{ translation.t('adminDepManagement', 'status') }}</th>
          <th>{{ translation.t('adminDepManagement', 'actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let mapping of pagedDepartments ;let i=index">
          <td class="text-center">{{ i+1 }}</td>
          <td>
            <div [innerHTML]="formatDepartmentName(mapping.department_name)"></div>
          </td>
          <td><span class="code">{{ mapping.dep_cd }}</span></td>
          <!-- <td class="text-center">{{ mapping.escalationStartLevel }}</td> -->
          <!-- <td>
            <div class="d-flex flex-wrap gap-1" [title]="getTooltipText(mapping.complaint_type_list)">
              <span *ngFor="let item of mapping.complaint_type_list | slice:0:3" class="badge bg-secondary">
                {{ getComplaintTypeName(item) }}
              </span>
              <span *ngIf="mapping.complaint_type_list?.length > 3" class="badge bg-secondary">
                +{{ mapping.complaint_type_list.length - 3 }}
              </span>
            </div>
          </td> -->
          <td>
            <span class="badge" style="border-radius: 6px;padding: 6px;" [ngStyle]="{
    'background-color': mapping.status === 'Active' ? '#226CE0' : '#226CE0',
    'color': 'white'
   }">
              {{ mapping.status }}
            </span>

          </td>
          <td class="text-center" style="padding: 0px 6px !important;">
            <div class="action-btn-wrapper">
              <button class="me-1 edit" (click)="open(addDepartmentModal, mapping)">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <g clip-path="url(#clip0_582_5824)">
                    <path
                      d="M7.83325 3.16665H3.16659C2.81296 3.16665 2.47382 3.30713 2.22378 3.55718C1.97373 3.80723 1.83325 4.14637 1.83325 4.49999V13.8333C1.83325 14.1869 1.97373 14.5261 2.22378 14.7761C2.47382 15.0262 2.81296 15.1667 3.16659 15.1667H12.4999C12.8535 15.1667 13.1927 15.0262 13.4427 14.7761C13.6928 14.5261 13.8333 14.1869 13.8333 13.8333V9.16665M12.8333 2.16665C13.0985 1.90144 13.4582 1.75244 13.8333 1.75244C14.2083 1.75244 14.568 1.90144 14.8333 2.16665C15.0985 2.43187 15.2475 2.79158 15.2475 3.16665C15.2475 3.54173 15.0985 3.90144 14.8333 4.16665L8.49992 10.5L5.83325 11.1667L6.49992 8.49999L12.8333 2.16665Z"
                      stroke="#1E1E1E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_582_5824">
                      <rect width="16" height="16" fill="white" transform="translate(0.5 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button class="delete" (click)="deleteDepartment(mapping)">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                  <path d="M9.66675 14.25L9.66675 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round" />
                  <path d="M13.3333 14.25L13.3333 11.5" stroke="#F52525" stroke-width="2" stroke-linecap="round" />
                  <path
                    d="M3.25 6.91666H19.75V6.91666C19.0522 6.91666 18.7033 6.91666 18.4194 7.00278C17.7802 7.19668 17.28 7.69688 17.0861 8.33609C17 8.61998 17 8.96888 17 9.66666V14.8333C17 16.7189 17 17.6618 16.4142 18.2475C15.8284 18.8333 14.8856 18.8333 13 18.8333H10C8.11438 18.8333 7.17157 18.8333 6.58579 18.2475C6 17.6618 6 16.7189 6 14.8333V9.66666C6 8.96888 6 8.61998 5.91388 8.33609C5.71998 7.69688 5.21977 7.19668 4.58057 7.00278C4.29667 6.91666 3.94778 6.91666 3.25 6.91666V6.91666Z"
                    stroke="#F52525" stroke-width="1.5" stroke-linecap="round" />
                  <path
                    d="M9.72906 3.58971C9.83351 3.49225 10.0637 3.40613 10.3839 3.34471C10.704 3.28329 11.0963 3.25 11.4999 3.25C11.9035 3.25 12.2958 3.28329 12.616 3.34471C12.9362 3.40613 13.1663 3.49225 13.2708 3.58971"
                    stroke="#F52525" stroke-width="2" stroke-linecap="round" />
                </svg>
              </button>
            </div>
          </td>


        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="d-flex justify-content-end align-items-end mt-3 flex-wrap">
  <span style="color: #6D6D6D; font-size: 14px;">
    {{ translation.t('adminDepManagement', 'showing') }} {{ pagedDepartments.length }} {{ translation.t('common', 'of') }} {{ filteredDepartmentList.length }} {{ translation.t('adminDepManagement', 'departments') }}
  </span>

  <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
    <label class="me-1">{{ translation.t('adminDepManagement', 'perPage') }}</label>
    <select [(ngModel)]="pageSize" (change)="changePageSize()" class="form-select form-select-sm w-auto">
      <option *ngFor="let size of page_list" [value]="size">{{ size }}</option>
    </select>

    <button class="btn-sm fw-bold px-3 py-1 me-2" (click)="prevPage()" [disabled]="currentPage === 1">&lt;</button>

    <span style="font-weight: 600;">{{ currentPage }} / {{ totalPages }}</span>

    <button class="btn-sm fw-bold px-3 py-1" (click)="nextPage()" [disabled]="currentPage === totalPages">&gt;</button>
  </div>
</div>

<ng-template #addDepartmentModal let-modal>
  <div class="modal-content">

    <div class="modal-header">
      <div>
        <h3 class="modal-title">{{ isEditMode ? translation.t('adminDepManagement', 'editDepartment') : translation.t('adminDepManagement', 'addNewDepartment') }}</h3>
        <p class="text-muted mb-0">
          {{ isEditMode ? translation.t('adminDepManagement', 'updateDetails') : translation.t('adminDepManagement', 'enterDetails') }}
        </p>

      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
          <path d="M17.6333 32.3646L32.3666 17.6354M17.6333 17.6354L32.3666 32.3646" stroke="black" stroke-width="1.5"
            stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <div class="modal-body">

      <div class="row g-3 mb-3 mt-1">
        <div class="col-12 col-md-6">
          <label class="form-label">{{ translation.t('adminDepManagement', 'departmentName') }}<span class="text-danger">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="newDepartment.department_name"
            placeholder="{{ translation.t('adminDepManagement', 'enterDepartmentName') }}">
        </div>

        <div class="col-12 col-md-6">
          <label class="form-label">{{ translation.t('adminDepManagement', 'departmentCode') }}<span class="text-danger">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="newDepartment.dep_cd" placeholder="{{ translation.t('adminDepManagement', 'enterDepartmentCode') }}"
            [disabled]="isEditMode">
        </div>
      </div>

      <div class="row g-3 mb-3">
        <!-- <div class="col-12 col-md-6">
          <label class="form-label">Escalation Start Level</label>
          <ng-select [items]="escalationLevels" bindLabel="" bindValue=""
            [(ngModel)]="newDepartment.escalationStartLevel" placeholder="Select" [searchable]="false">
          </ng-select>
        </div> -->

        <div class="col-12 col-md-6">
          <div class="active-status-main">
            <div class="active-status-label">{{ translation.t('adminDepManagement', 'activeStatus') }}</div>
            <div class="active-status-toggle">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [(ngModel)]="newDepartment.status" id="activeToggle">
                <label class="form-check-label" for="activeToggle"></label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- due to user no need of शिकायत के प्रकार -->
      <!-- <div class="row g-3 mb-3">
        <div class="col-12">
          <label class="form-label">{{ translation.t('adminDepManagement', 'complaintTypes') }}</label>
          <div class="input-group mb-2">
            <input type="text" class="form-control" [(ngModel)]="complaintTypeInput"
              placeholder="{{ translation.t('adminDepManagement', 'enterComplaintTypeName') }}">
            <input type="text" class="form-control" [(ngModel)]="complaintTypeCodeInput"
              (keyup.enter)="addComplaintType()" placeholder="{{ translation.t('adminDepManagement', 'enterCode') }}">
            <button class="btn btn-primary" type="button" (click)="addComplaintType()">{{ translation.t('adminDepManagement', 'add') }}</button>
          </div>
          <div class="d-flex flex-wrap gap-2">
            <span *ngFor="let item of newDepartment.complaint_type; let i = index"
              class="badge bg-light text-dark border d-flex align-items-center p-2">
              {{ getComplaintTypeName(item) }} ({{ getComplaintTypeCode(item) }})
              <span class="ms-2 cursor-pointer text-danger" (click)="removeComplaintType(i)"
                style="cursor: pointer;">&times;</span>
            </span>
          </div>
        </div>
      </div> -->

    </div>

    <div class="modal-footer">
      <button type="button" class="btn cancel" (click)="modal.dismiss()">{{ translation.t('adminDepManagement', 'cancel') }}</button>
      <button *ngIf="!isEditMode" type="button" class="btn add" (click)="addDepartment()">{{ translation.t('adminDepManagement', 'addDepartment') }}</button>
      <button *ngIf="isEditMode" type="button" class="btn add" (click)="updateDepartment()">{{ translation.t('adminDepManagement', 'updateDepartment') }}</button>
    </div>

  </div>
</ng-template>